import { create } from 'zustand';
import { logger } from '@/features/help/utils/logger';

interface HelpState {
  isContactModalOpen: boolean;
  openContactModal: () => void;
  closeContactModal: () => void;
}

/**
 * Zustand store for managing help-related UI state, such as modals.
 */
export const useHelpStore = create<HelpState>((set) => ({
  isContactModalOpen: false,
  openContactModal: () => {
    logger.info('HelpStore', 'Opening Contact Modal');
    set({ isContactModalOpen: true });
  },
  closeContactModal: () => {
    logger.info('HelpStore', 'Closing Contact Modal');
    set({ isContactModalOpen: false });
  },
}));
